import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import accountSlice from './slices/account.slices';
import commandesRealiseesFiltrerSlice from './slices/commandes-realisees-iltrer.slices';

const store = configureStore({
  reducer: {
    account: accountSlice,
    commandesRealiseesFiltrer: commandesRealiseesFiltrerSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
